
// Variables concerning the app in general
export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes";
export const API_KEY = "6a725b4a-0cc3-4a80-8368-49cdb37140cd";

// Variables concerning the helpers.js
export const TIMEOUT_SECONDS = 10;

// Variables concerning the model.js
export const STARTING_RESULTS_PAGE = 1;
export const RESULTS_PER_PAGE = 10;

// Variables concering the controller.js
export const MODAL_CLOSE_MILSEC = 1500;